import { render, staticRenderFns } from "./TabDetails.vue?vue&type=template&id=ca24c5e2&"
import script from "./TabDetails.vue?vue&type=script&lang=js&"
export * from "./TabDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports